import { render, staticRenderFns } from "./PlateNumberInput.vue?vue&type=template&id=6b510d7b&scoped=true&"
import script from "./PlateNumberInput.vue?vue&type=script&lang=js&"
export * from "./PlateNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./PlateNumberInput.vue?vue&type=style&index=0&id=6b510d7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b510d7b",
  null
  
)

export default component.exports